export default __webpack_public_path__ + "static/media/email_icon.47b17c45.png";